// extracted by mini-css-extract-plugin
export default {"content":"P7aySctqoMk44JmFeuOb","body":"HAILNYKv_Lux3L6dsV1x","scroll":"iRYogy_FDGZ6Nmaq2obT"};